import React from 'react';
import styles from 'components/Player/AudioPlayerWrapper/PlayQueue/PlayQueue.module.scss';
import CurrentlyPlaying from 'components/Player/AudioPlayerWrapper/PlayQueue/CurrentlyPlaying';
import NextInQueueList from 'components/Player/AudioPlayerWrapper/PlayQueue/NextInQueueList';
import NextInList from 'components/Player/AudioPlayerWrapper/PlayQueue/NextInList';
import { useTranslation } from 'hooks/useTranslation';
import { useTunnusContext } from 'contexts/TunnusContext';
import LoginPromotion from 'components/Player/AudioPlayerWrapper/PlayQueue/LoginPromotion';
import EmptyPlayQueue from 'components/Player/AudioPlayerWrapper/PlayQueue/EmptyPlayQueue';
import { usePlayerState } from 'contexts/PlayerStateContext';
import { Card } from '@yleisradio/areena-types';
import { DialogTitle } from 'components/Dialog/Dialog';

type Props = {
  ongoingCard: Card | undefined;
};

export function PlayQueue({ ongoingCard }: Props) {
  const { activePlayer, queue } = usePlayerState();
  const t = useTranslation();
  const { isAuthenticated } = useTunnusContext();

  const cardsInQueue = Boolean(ongoingCard || queue?.length);

  return (
    <div className={styles.queue}>
      <DialogTitle asChild>
        <h2 className={styles.title}>{t('queue')}</h2>
      </DialogTitle>

      {cardsInQueue && isAuthenticated && (
        <>
          <CurrentlyPlaying />
          {queue.length > 0 && <NextInQueueList itemIds={queue} />}
          {activePlayer?.playlistSource && (
            <NextInList
              heading={t('nextInSeries')}
              source={activePlayer.playlistSource}
              listKey="play-queue-next-in-series"
            />
          )}
          {activePlayer?.recommendationsSource && (
            <NextInList
              heading={t('recommendationsInQueue')}
              source={activePlayer.recommendationsSource}
              listKey="play-queue-recommendations"
            />
          )}
        </>
      )}
      {!cardsInQueue && isAuthenticated && <EmptyPlayQueue />}
      {!isAuthenticated && <LoginPromotion />}
    </div>
  );
}
